<template>
  <div class="projects-box">
    <menuBox :step="2"></menuBox>
    <div class="title-box">
      Privacy Policy
    </div>
    <div class="content">
      Privacy and Copyright Protection Agreement<br>

      Welcome to use the short drama APP developed by HATFUL LIMITED (hereinafter referred to as "we"). We are committed
      to protecting the privacy and security of our users and respecting and protecting the copyright of all content. By
      using our APP, you agree to abide by the following privacy and copyright protection policy terms:<br>

      1. Privacy protection:<br>

      Our purpose of collecting user information is to provide better services and improve user experience. The types of
      information collected may include, but are not limited to, user names, contact information, and payment information.
      We promise not to disclose user information to any third party without the user's consent, unless required by laws
      and regulations or explicitly authorized by the user.<br>
      2. Copyright protection:<br>

      All short drama content provided by our APP has cooperative relationships with relevant producers and has been
      legally authorized. Any unauthorized reproduction, distribution, dissemination, public display or other copyright
      infringement is prohibited.<br>
      The way users obtain gold coins by paying or completing tasks, and using gold coins to unlock short plays, does not
      mean that users obtain any ownership or copyright of the short plays. All content remains the property of the
      original publisher.<br>
      3. User Responsibilities:<br>

      Users should abide by all relevant copyright laws and regulations and respect the copyright and intellectual
      property rights of the content.<br>
      Users are not allowed to use the APP to conduct any behavior that infringes on the copyright or intellectual
      property rights of others.<br>
      4. Copyright complaints:<br>

      If you believe that some content within the APP infringes upon your copyright, please submit a copyright complaint
      to us through official channels and we will handle it as soon as possible after receiving the notification.<br>
      We reserve the right to update this Agreement at any time and will notify users through the APP or official website.
      Continued use of the APP will be deemed as the user's acceptance of the modified agreement. HATFUL LIMITED reserves
      the right to interpret this agreement.<br>

      Thank you for your understanding and support.<br>

      HATFUL LIMITED<br>
    </div>
    <footerBox :step="4"></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "projects",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
    };
  },
  mounted() { },
  methods: {
    submit() {
      alert('success!')
    }
  },
};
</script>
<style lang="less" scoped>
.projects-box {
  background: #191A20;

  .title-box {
    margin: 0 305px;
    background-image: url(../assets/projects.png);
    height: 175px;
    line-height: 175px;
    text-align: center;
    background-size: 100% 100%;
    overflow: hidden;
    box-sizing: border-box;
    font-size: 42px;
    font-family: Roboto, Roboto;
    font-weight: 600;
    color: #FFFFFF;
    box-sizing: border-box;
  }
}

.content {
  padding: 50px 305px;
  font-size: 18px;
  font-family: Roboto, Roboto;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 32px;
}
</style>
